export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FavouritesShare.vue?vue&type=template&id=66dc0791&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FavouritesShare.vue?vue&type=template&id=66dc0791&
// module id = 169
// module chunks = 6